import { useViewData } from "../view-data";
import { useViewModel } from "../view-model";

import type * as Repository from "../../../_repository";

type Props = {
	hotelID: string;
	// オプションリスト
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
	// 色（オプション）ごとにまとめて並べるかどうか
	groupByOptionID: boolean;
};

export const useInitialized = ({
	optionPmsActiveListQueryData,
	optionPmsColorListQueryData,
	groupByOptionID,
}: Props) => {
	/**
	 * ViewModel の生成
	 */
	const {
		//
		viewModel,
		// オプションの選択
		onSetCardIDOfOption,
		// オプションの選択解除
		onClearCardIDOfOption,
	} = useViewModel({ groupByOptionID });

	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({ viewModel, optionPmsColorListQueryData, optionPmsActiveListQueryData });

	return {
		//
		viewData,
		//
		// オプションの選択
		onSetCardIDOfOption,
		// オプションの選択解除
		onClearCardIDOfOption,
	};
};
